import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

/**
 * Utilidad para fusionar clases de Tailwind CSS sin conflictos.
 * 
 * @param {...(string|Object|Array)} inputs - Clases a fusionar.
 * @returns {string} - Cadena de clases fusionada.
 */
export function cn(...inputs) {
  return twMerge(clsx(inputs));
}
